const categorizeErrors = (data) => {
  //////////////////////////////Categorizar los errores para luego mostrarlos en el modal de advertencia /////////////////////////////////
  try {
    let categorizedErrors = [
      {
        type: "deposition",
        textName: "Relato",
        passed: false,
        errorsMessagesToSearch: [
          "El relato de la denuncia debe contener como minimo 600 caracteres",
        ],
      },
      {
        type: "interveningPersonnel",
        textName: "Personal interviniente",
        passed: false,
        errorsMessagesToSearch: ["No especificó al Personal Interviniente"],
      },
      {
        type: "datesAndLocations",
        textName: "Fecha, hora y ubicación",
        passed: false,
        errorsMessagesToSearch: [
          "Falta fecha del hecho",
          "La fecha del hecho no puede ser posterior a la fecha actual",
          "Verificar fecha del hecho",
          "Falta geolocalización",
          "Falta lugar del hecho",
          "Falta ubicación del hecho",
          "Verificar el orden de las fechas del hecho",
        ],
      },
      {
        type: "affecteds",
        textName: "Afectados",
        passed: false,
        errorsMessagesToSearch: [
          "Falta DNI del damnificado",
          "Debe especificar al menos un Damnificado de tipo Orden Público",
          "Falta DNI del denunciante y/o damnificado",
          "Falta teléfono del denunciante y/o damnificado",
          "Falta teléfono del damnificado",
          "Falta email del denunciante",
          "Al menos 1 afectado tiene un email con formato incorrecto",
          "Falta apellido del denunciante y/o damnificado",
          "Falta apellido del damnificado",
          "Falta nombre del denunciante y/o damnificado",
          "Falta nombre del damnificado",
          "Falta estado civil del denunciante y/o damnificado",
          "Falta estado civil del damnificado",
          "Falta fecha de nacimiento del denunciante y/o damnificado",
          "Falta fecha de nacimiento del damnificado",
          "Falta domicilio del denunciante y/o damnificado",
          "Falta domicilio del damnificado",
        ],
      },
      {
        type: "legalData",
        textName: "Datos legales",
        passed: false,
        errorsMessagesToSearch: [
          "No se ingresaron Articulos relacionados con la Falta",
          "Falta N° de UFI",
          "Falta carátula",
          "Falta delito",
          "Falta un Fiscal a cargo",
          "Falta un Ayudante de Fiscal",
          "Falta modus operandi",
          "Falta juzgado interviniente",
          "Falta número de sumario / causa",
          "Falta número de LEGAJO/Extracto",
          "Falta número de Expediente",
          "Falta número de ACT. Preliminar / Nº de extracto",
        ],
      },
    ];
    validateErrors(categorizedErrors, data.errorValidationErr);
    categorizedErrors = sortResults(categorizedErrors);
    return categorizedErrors;
  } catch (e) {
    console.log("FALLO la categorización de errores: ", e);
  }
};

const validateErrors = (categorizedErrors, errorValidationErr) => {
  for (let index = 0; index < categorizedErrors.length; index++) {
    categorizedErrors[index].passed = !categorizedErrors[index].errorsMessagesToSearch.some(
      (item) => errorValidationErr.includes(item)
    );
  }
};

const sortResults = (categorizedErrors) => {
  const order = [
    "Afectados",
    "Fecha, hora y ubicación",
    "Personal interviniente",
    "Datos legales",
    "Relato",
  ];
  categorizedErrors.sort((a, b) => {
    return order.indexOf(a.textName) - order.indexOf(b.textName);
  });
  return categorizedErrors;
};

export default {
  categorizeErrors,
};
